import { useState, useEffect } from 'react';

const stats = [
  { label: '日更漫画', value: '200+', icon: 'ri-fire-line' },
  { label: '漫画总数', value: '50,000+', icon: 'ri-book-open-line' },
  { label: '累计读者', value: '800万+', icon: 'ri-user-heart-line' },
];

export default function Hero() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { setLoaded(true); }, []);

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 md:pt-20 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className={`flex-1 w-full transition-all duration-700 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}>
            <div className="flex flex-wrap gap-2 mb-4">
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                <i className="ri-sparkling-2-line text-sm"></i>日漫精选
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                <i className="ri-fire-line text-sm"></i>韩漫热榜
              </span>
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                <i className="ri-flag-line text-sm"></i>国漫新番
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-3">
              酷漫屋 · 免费漫画全集在线阅读
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading mb-5">
              日漫韩漫国漫，下拉式滚动畅读，追更不等待
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mb-6">
              酷漫屋汇聚海量免费漫画资源，覆盖热血、恋爱、奇幻、悬疑等全题材类型。每日稳定更新200+章节，支持下拉式滚动阅读体验，无需翻页即可畅享沉浸式追漫。无论你是日漫死忠、韩漫爱好者还是国漫追随者，这里都是你免费的漫画之家。
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-7">
              {stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className={`${stat.icon} text-primary-500 text-sm`}></i>
                  </div>
                  <div>
                    <div className="text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap">{stat.value}</div>
                    <div className="text-xs text-foreground-500 whitespace-nowrap">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>开始探索漫画
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border-2 border-primary-200 text-primary-600 font-medium text-sm whitespace-nowrap hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <i className="ri-trophy-line"></i>查看热门排行
              </a>
            </div>
          </div>

          <div className={`flex-1 w-full max-w-lg lg:max-w-none transition-all duration-700 delay-200 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}>
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/30 via-accent-200/20 to-secondary-200/30 rounded-3xl blur-2xl"></div>
              <div className="relative grid grid-cols-2 gap-3 md:gap-4">
                <div className="space-y-3 md:space-y-4 pt-6">
                  <div className="w-full aspect-[3/4] rounded-2xl overflow-hidden bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20manga%20cover%20illustration%20featuring%20a%20dynamic%20action%20scene%20with%20a%20young%20warrior%20in%20traditional%20Japanese%20armor%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20red%20tones%2C%20clean%20flat%20illustration%20style%2C%20bold%20lines%2C%20white%20background&width=600&height=800&seq=hero-manga-01&orientation=portrait"
                      alt="热血漫画推荐"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Colorful%20romance%20manga%20style%20illustration%20of%20two%20characters%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20peach%20color%20palette%2C%20clean%20anime%20art%20style%2C%20dreamy%20atmosphere%2C%20simple%20white%20background%2C%20modern%20illustration&width=600&height=450&seq=hero-manga-02&orientation=landscape"
                      alt="恋爱漫画推荐"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
                <div className="space-y-3 md:space-y-4">
                  <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Fantasy%20adventure%20manga%20illustration%20with%20magical%20creatures%20and%20a%20young%20mage%2C%20bright%20golden%20and%20emerald%20tones%2C%20clean%20anime%20art%20style%2C%20whimsical%20atmosphere%2C%20minimal%20background%2C%20Japanese%20manga%20aesthetic&width=600&height=450&seq=hero-manga-03&orientation=landscape"
                      alt="奇幻漫画推荐"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="w-full aspect-[3/4] rounded-2xl overflow-hidden bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=Suspenseful%20thriller%20manga%20cover%20style%20illustration%20with%20mysterious%20silhouette%20and%20urban%20night%20scene%2C%20dark%20amber%20and%20crimson%20accents%2C%20clean%20modern%20art%20style%2C%20dramatic%20composition%2C%20neutral%20beige%20background&width=600&height=800&seq=hero-manga-04&orientation=portrait"
                      alt="悬疑漫画推荐"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}